// extracted by mini-css-extract-plugin
export default {"formButtons":"GeneralFormButtons_formButtons__n1gD-","loader":"GeneralFormButtons_loader__gqncr","spin":"GeneralFormButtons_spin__1Ueve"};